import { ContentDialogActionTypes } from "infrastructure/store/contentDialog/ContentDialogActionTypes";
import ContentDialogState from "infrastructure/store/contentDialog/ContentDialogState";
import IAppState from "infrastructure/store/IAppState";
import React, { ReactElement } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ModalHeader from "features/shared/components/modal/ModalHeader";

interface Props {
  show: boolean;
  renderContent?: () => JSX.Element;
}

const ContentDialog = () => {
  // store
  const dispatch = useDispatch();
  const dialogState = useSelector<IAppState, ContentDialogState>(
    (store) => store.contentDialog
  );

  // private props
  const { renderContent, showDialog, size, title, closable, animated } = dialogState;

  // handlers
  const closeDialogHandler = () => {
    dispatch({
      type: ContentDialogActionTypes.SET_CONTENT_DIALOG,
      data: {
        showDialog: false,
        title: "",
        renderContent: undefined,
      },
    });
  };

  // render
  return (
    <Modal
      show={showDialog}
      onHide={closeDialogHandler}
      size={size}
      backdrop={closable !== undefined && !closable ? "static" : true}
      animation={animated}
      keyboard={closable}
    >
      <ModalHeader
        title={title}
        onCloseClick={
          closable !== undefined && !closable ? undefined : closeDialogHandler
        }
      />
      <div className="modal-body p-0">{renderContent && renderContent()}</div>
    </Modal>
  );
};

export default ContentDialog;
